import axios from "axios";
import { kopfzeilen } from "./ablauf";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
  }
  // Ablaufaufzeichnung: Vorgang/Aktion/Programmversion mitgeben (08.10.2026)
  try { config.headers = { ...config.headers, ...kopfzeilen() }; } catch { /* nie stören */ }
  return config;
});
